<template>
    <button
        class="btn btn-hollow border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white"
        @click="reset"
    >
        <slot></slot>
    </button>
</template>
<script>
import EventBus from '../utils/eventBus';
export default {
    name: 'reset-rooms-button',
    methods: {
        reset() {
            EventBus.$emit('rooms-list-reset');
        }
    }
}
</script>
